import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { GeneratedOption, GenerateOptionsResponse } from '../../dtos/glai.dto';
import { GlaiService } from '../../services/glai/glai.service';
import { ModalComponent, ModalConfig } from '../modals/modal/modal.component';

@Component({
  selector: 'app-ai-options-modal',
  templateUrl: './ai-options-modal.component.html',
  styleUrls: ['./ai-options-modal.component.scss'],
  standalone: false,
})
export class AiOptionsModalComponent {
  @ViewChild('aiOptionsModal')
  aiOptionsModal: ModalComponent;

  @Input() competencyId: number;

  @Input() strandId: number;

  @Input() level: number;

  @Output() readonly optionsSelected = new EventEmitter<GeneratedOption[]>();

  modalConfig: ModalConfig = {
    titleText: 'Smart Options',
    headerClass: ['modal-header', 'bg-primary', 'text-white'],
    customFooter: true,
    options: {
      size: 'lg',
    },
  };

  isLoading = false;

  generatedOptions: GenerateOptionsResponse | null = null;

  visibleOptions: GeneratedOption[] | null;

  hasSelections = false;

  error: string | null = null;

  constructor(private glaiService: GlaiService) {}

  openModal() {
    this.aiOptionsModal.open();
    this.generateOptions();
  }

  closeModal() {
    this.aiOptionsModal.close();
  }

  toggleOption(option: GeneratedOption) {
    if (this.generatedOptions) {
      option.selected = !option.selected;
      this.hasSelections = this.generatedOptions?.options.some(
        (opt) => opt.selected
      );
    }
  }

  submitFeedback(option: GeneratedOption, direction: string): void {
    if (!option.glai_content_id) return;
    option.user_feedback = direction;
    this.glaiService
      .submitGlaiContentFeedback(option.glai_content_id, direction)
      .subscribe();
  }

  addSelectedOptions() {
    const selected =
      this.generatedOptions?.options.filter((opt) => opt.selected) || [];
    this.optionsSelected.emit(selected);
    this.closeModal();
  }

  showMore() {
    let newLength = 3;
    if (!this.generatedOptions) return;
    if (this.visibleOptions) {
      newLength = this.visibleOptions.length + 1;
      if (newLength > this.generatedOptions.options.length) {
        newLength = this.generatedOptions.options.length;
      }
    }
    this.visibleOptions = this.generatedOptions?.options.slice(0, newLength);
  }

  generateOptions() {
    // Implementation for generating AI options
    this.isLoading = true;
    this.error = null;
    this.generatedOptions = null;
    this.visibleOptions = [];
    this.hasSelections = false;
    this.glaiService
      .generateEgroweOptions(this.competencyId, this.strandId, this.level)
      .subscribe({
        next: (response) => {
          this.isLoading = false;
          this.generatedOptions = response;
          this.visibleOptions = response.options.slice(0, 3);
        },
        error: (error) => {
          this.isLoading = false;
          this.error = `Failed to generate options : ${error}`;
        },
      });
  }
}
